import Topnav from './components/Nav/TopBar';
import Sidebar from './components/Nav/SideBar';

import { useStateContext } from './components/Context/ContextProvider';
import AuthToken from './components/Context/AuthToken';
import ProtectedRoute from './components/Context/ProtectedRoute';
import AdminRoute from './components/Context/AdminRoute'
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { useLocation } from 'react-router-dom'

import Home from './pages/Home';
import Login from './pages/Login';
import TwoFaLogin from './pages/TwoFaLogin'
import ListUsers from './pages/Admins/ListAdmins'
import AddUsers from './pages/Admins/AddAdmin'
import UpdateUser from './pages/Admins/UpdateAdmin'
import Profile from './pages/Admins/Profile'
import Clients from './pages/Clients/Clients'
import AddClient from './pages/Clients/AddClient'
import ViewClient from './pages/Clients/ViewClient'
import BankTransactions from './pages/Topup/BankTransactions'
import MpesaTransactions from './pages/Topup/MpesaTransactions'
import Successful from './pages/Reports/Successful'
import Failed from './pages/Reports/Failed'
import Reports from './pages/Reports/Reports'
import Unauthorised from './pages/Unauthorised'

const App = () => {
  const { activeMenu } = useStateContext();
  const location = useLocation();
  

  const { accessToken, setAccessToken } = AuthToken();
  if (!accessToken) {
    return <Login setAccessToken={setAccessToken} />;
  }

  // Hide Sidebar & Topnav on specific pages
  const hideLayout = location.pathname === "/2fa-login";

  return (
    <main>
      <div className='flex relative'>
        {!hideLayout && activeMenu && (
          <div className='lg:w-48 xl:w-52 2xl:w-60 fixed'>
            <Sidebar />
          </div>
          )}
        <div className={activeMenu && !hideLayout ? 'min-h-screen lg:ml-48 xl:ml-52 2xl:ml-60 w-full' : 'w-full min-h-screen flex-2'}>
          <div>
            {!hideLayout && <Topnav />}
            <Toaster position='top-center' richColors />
            <Routes>
              {/* dashboard  */}
              <Route path='/' element={<Home />} />
              <Route path='/unauthorised' element={<Unauthorised />} />
              <Route path='/2fa-login' element={<TwoFaLogin setAccessToken={setAccessToken} />} />
              <Route path='/login' element={<Login setAccessToken={setAccessToken} />} />
              {/* <Route path='/admins' element={<ProtectedRoute><ListUsers /></ProtectedRoute>} />
              <Route path='/addadmin' element={<ProtectedRoute><AddUsers /></ProtectedRoute>} />
              <Route path='/updateadmin/:id' element={<ProtectedRoute><UpdateUser /></ProtectedRoute>} /> */}
              <Route path='/my-profile' element={<Profile />} />
              <Route path='/clients' element={<Clients />} />
              <Route path='/addclient' element={<AddClient />} />
              <Route path='/client/:id' element={<ViewClient />} />
              <Route path='/successful' element={<Successful />} />
              <Route path='/failed' element={<Failed />} />
              <Route path='/reports' element={<Reports />} />
              <Route path='/bank' element={<AdminRoute><BankTransactions /></AdminRoute>} />
              <Route path='/mpesa' element={<AdminRoute><MpesaTransactions /></AdminRoute>} />
            </Routes>
          </div>
        </div>
      </div>
    </main>
  );
};

export default App;
